document.addEventListener('DOMContentLoaded', () => {

    const jscode = document.querySelectorAll('.js-code');
    jscode.forEach((item, index) => {

        item.addEventListener('input',(e)=>{
            const value = item.value;
            if(value.length>1){
               const lastval = value.toString().slice(-1);
               item.value = lastval;
            }
            if (value.length == 1){
                item.classList.add('filled');
                const next = item.nextElementSibling;
                if(typeof next !== 'undefined' && next !== null){
                    next.focus();
                }
            }
            else{
                item.classList.remove('filled');
            }
        });

        item.addEventListener('keyup',(e)=>{
            let key = e.which || e.keyCode || e.charCode;
            if(key == 8 || key == 37){
                const prev = item.previousElementSibling;
                if(typeof prev !== 'undefined' && prev !== null){
                    prev.focus();
                }
            }
        });

        item.addEventListener('focus',(e)=>{
            item.select();
        });



    });

});
